/*
 * bpmbuild-uat-ds.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/ChartDataBean', 'model/GoogleChartOptionsBean'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./ChartDataBean'), require('./GoogleChartOptionsBean'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildUatDsappspotcom) {
      root.BpmbuildUatDsappspotcom = {};
    }
    root.BpmbuildUatDsappspotcom.ChartBean = factory(root.BpmbuildUatDsappspotcom.ApiClient, root.BpmbuildUatDsappspotcom.ChartDataBean, root.BpmbuildUatDsappspotcom.GoogleChartOptionsBean);
  }
}(this, function(ApiClient, ChartDataBean, GoogleChartOptionsBean) {
  'use strict';

  /**
   * The ChartBean model module.
   * @module model/ChartBean
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>ChartBean</code>.
   * @alias module:model/ChartBean
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>ChartBean</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ChartBean} obj Optional instance to populate.
   * @return {module:model/ChartBean} The populated <code>ChartBean</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('chartData'))
        obj.chartData = ChartDataBean.constructFromObject(data['chartData']);
      if (data.hasOwnProperty('chartOptions'))
        obj.chartOptions = GoogleChartOptionsBean.constructFromObject(data['chartOptions']);
      if (data.hasOwnProperty('chartType'))
        obj.chartType = ApiClient.convertToType(data['chartType'], 'String');
      if (data.hasOwnProperty('tableType'))
        obj.tableType = ApiClient.convertToType(data['tableType'], 'String');
    }
    return obj;
  }

  /**
   * @member {module:model/ChartDataBean} chartData
   */
  exports.prototype.chartData = undefined;

  /**
   * @member {module:model/GoogleChartOptionsBean} chartOptions
   */
  exports.prototype.chartOptions = undefined;

  /**
   * @member {module:model/ChartBean.ChartTypeEnum} chartType
   */
  exports.prototype.chartType = undefined;

  /**
   * @member {module:model/ChartBean.TableTypeEnum} tableType
   */
  exports.prototype.tableType = undefined;


  /**
   * Allowed values for the <code>chartType</code> property.
   * @enum {String}
   * @readonly
   */
  exports.ChartTypeEnum = {
    /**
     * value: "PIE"
     * @const
     */
    PIE: "PIE",

    /**
     * value: "AREA"
     * @const
     */
    AREA: "AREA",

    /**
     * value: "BAR"
     * @const
     */
    BAR: "BAR",

    /**
     * value: "TIMELINE"
     * @const
     */
    TIMELINE: "TIMELINE",

    /**
     * value: "GUAGE"
     * @const
     */
    GUAGE: "GUAGE",

    /**
     * value: "COMBO"
     * @const
     */
    COMBO: "COMBO",

    /**
     * value: "GANTT"
     * @const
     */
    GANTT: "GANTT",

    /**
     * value: "BUBBLE"
     * @const
     */
    BUBBLE: "BUBBLE"
  };


  /**
   * Allowed values for the <code>tableType</code> property.
   * @enum {String}
   * @readonly
   */
  exports.TableTypeEnum = {
    /**
     * value: "PIVOT"
     * @const
     */
    PIVOT: "PIVOT"
  };

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsUatds/src/model/ChartBean.js